export let operations = [
	{ id:'contains',label:'contains' },
	{ id:'!contains',label:'notContains' },
	{ id:'==',label:'equals' },
	{ id:'!=',label:'notEqual' },
	{ id:'starts with',label:'startsWith' },
	{ id:'ends with',label:'endsWith' },
];

import objGet from '../objGet';

export function filterFactory(columnDef, op, ...compValues) {
	let compValue;
	let valueGetter;
	if (columnDef.comparableValueGetter)
		valueGetter = columnDef.comparableValueGetter;
	else if (columnDef.valueGetter)
		valueGetter = columnDef.valueGetter;
	else
		valueGetter = (item) => objGet(item,columnDef.field);

	compValue = compValues[0].toLowerCase();
	switch (op) {
	case '==':
		return (item) => {
			let list = valueGetter(item);
			return list.some( val => (`${val}`).toLowerCase() === compValue);
		};
	case '!=':
		return (item) => {
			let list = valueGetter(item);
			return list.every( val => (`${val}`).toLowerCase() !== compValue);
		};
	case 'contains':
		return (item) => {
			let list = valueGetter(item);
			return list.some( val => (`${val}`).toLowerCase().includes(compValue));
		};
	case '!contains':
		return (item) => {
			let list = valueGetter(item);
			return list.every( val => !(`${val}`).toLowerCase().includes(compValue));
		};
	case 'starts with':
		return (item) => {
			let list = valueGetter(item);
			return list.some( val => (`${val}`).toLowerCase().startsWith(compValue));
		};
	case 'ends with':
		return (item) => {
			let list = valueGetter(item);
			return list.some( val => (`${val}`).toLowerCase().endsWith(compValue));
		};
	default:
		throw new Error(`Unknown operation: ${  op}`);
	}
}